import React, { useState, useEffect, useContext, Fragment, useRef, useCallback } from 'react';

import AddressProcess from 'home/view/manage-feasibility/components/organisms/addressProcessAOI/addressProcess';
import DrawerModalComponent from 'home/view/manage-feasibility/components/organisms/drawer_modal';
import BottomSection from 'home/view/manage-feasibility/components/molecules/BottomSection';
import CancelModal from 'home/view/manage-feasibility/components/molecules/CancelModal';
import CustomModal from 'dedicated/components/customModal/customModal';

import {
  feasibilityReportDownload,
  fetchLocationDetails,
  cartSearch,
  cartCheckout,
  cancelLead,
  upgradeFetchCircuitDetails,
  retry4gFeasibility
} from 'home/view/manage-feasibility/services';

import {
  MULTI_SITE_MODULE_ID,
  AUTH_TOKEN,
  LEAD_ID,
  CART_ID,
  CART_STATUS,
  FILTER_TYPES,
  CALLBACK_DELAY,
  SHORT_CB_DELAY,
  LOCATIONS_SAVED,
  CREATED,
  SUCCESS_TOAST,
  DEFAULT_TOAST_MSG,
  WARNING_TOAST,
  ERROR_TOAST,
  FILE_UPLOAD_PAGES,
  LINE_ITEM_FIELDS_PARAMS
} from 'home/view/manage-feasibility/constants';

import {
  setInSessionStorage,
  getFromSessionStorage,
  findParamFromUrl,
  isAuthForDev,
  isDevEnv,
  scrollToRef,
  getOrderDetails,
  getCurrentServiceType,
  removeLastString,
  removeUnderScoreWithSpace,
  throttle
} from 'common/utils/app.utils';

import { isBulkUpgrade, isNLD_OR_LL, ROUTES, isVPN_OR_DI, FEASIBILITY_STATUS_ENUM, get4gFailureMessage, THROTTLE_TIMEOUT_4G } from 'common/constants/app.constants';

import { downloadFileURI, useInterval, getFileName, redirectToTMO } from 'home/view/manage-feasibility/utils';

import { AppContext } from 'App';

import './index.scss';
import { CART_STAGE, ORDER_STAGE, PLAN_CONFIGURATION, TOOLTIP_MESSAGE } from '../../constants/multiSite-constants';
import { getLeadIdAndCartId } from '../../utils/multiSite-utils';
import {
  DI_CART_HEADER,
  DI_FSB_HEADER,
  NLD_LL_CART_HEADER,
  NLD_LL_FSB_HEADER,
  UPGRADE_FEASIBILITY_HEADER,
  UPGRADE_CART_HEADER,
  VPN_FSB_HEADER,
  VPN_CART_HEADER
} from '../../constants/table-constant';
import { MediaType } from '../../components/organisms/addressProcessAOI/mediaType/mediaType';
import { getDownloadModalText, getFeasibilityWarningText } from 'home/view/check-feasibility/comp-generator/component.generator';
import CircuitDetail from 'home/view/manage-feasibility/components/organisms/CircuitDetail/CircuitDetail';

const defaultDataPerPageOptions = [
  { displayName: 'Show 10 Rows', key: '10' },
  { displayName: 'Show 20 Rows', key: '20' },
  { displayName: 'Show 30 Rows', key: '30' },
  { displayName: 'Show 40 Rows', key: '40' },
  { displayName: 'Show 50 Rows', key: '50' },
  { displayName: 'Show 60 Rows', key: '60' },
  { displayName: 'Show 70 Rows', key: '70' },
  { displayName: 'Show 80 Rows', key: '80' },
  { displayName: 'Show 90 Rows', key: '90' },
  { displayName: 'Show 100 Rows', key: '100' }
];

const defaultFilterOptions = [{ key: 'bandwidth', displayName: 'All' }];

const defaultSearchTypeOptions = [
  {
    key: 'pincode',
    displayName: 'Pincode',
    type: FILTER_TYPES.INPUT,
    regex: '[0-9]\\d*$'
  },
  {
    key: 'companyName',
    displayName: 'Company Name',
    type: FILTER_TYPES.INPUT
  }
];

const BulkFeasibilityComponent = (props) => {
  const partyId = findParamFromUrl('partyId', false);
  const leadIdFromParam = findParamFromUrl('leadId', false);
  const cartIdFromParam = findParamFromUrl('cartId', false);

  const getFsbTableColumns = () => {
    if (isBulkUpgrade()) {
      return UPGRADE_FEASIBILITY_HEADER;
    }

    if (isNLD_OR_LL()) {
      return NLD_LL_FSB_HEADER;
    }
    return VPN_FSB_HEADER;
  };

  const getCartTableColumns = () => {
    if (isBulkUpgrade()) {
      return UPGRADE_CART_HEADER;
    } else if (isNLD_OR_LL()) {
      return NLD_LL_CART_HEADER;
    }
    return VPN_CART_HEADER;
  };

  const fsb_tableHeader = getFsbTableColumns();
  const cart_tableHeader = getCartTableColumns();

  const { isdedicatedJourney, history } = props;
  const { showSteps, toast, setToast, setActiveStep } = useContext(AppContext);

  const [showLoader, setShowLoader] = useState(false);
  const [cartSitesLoading, setCartSitesLoading] = useState(false);
  const [selectedCartId, setSelectedCartId] = useState('');
  const [selectedCartStatus, setSelectedCartStatus] = useState('');
  const cartDataListRef = useRef([]);
  const cartContinerRef = useRef();

  const [isAccordionExpandedForFeasibilty, setIsAccordionExpandedForFeasibilty] = useState(true);
  const [isAccordionExpandedForCart, setIsAccordionExpandedForCart] = useState(false);

  // feasibility table state
  const [fsbTotalSitesProcessing, setFsbTotalSitesProcessing] = useState(0);
  const [fsbTotalSitesProcessed, setFsbTotalSitesProcessed] = useState(0);
  const [fsbTotalPages, setFsbTotalPages] = useState(0);
  const [fsbFeasibleSites, setFsbFeasibleSites] = useState(0);
  const [fsbManualFeasibleSites, setFsbManualFeasibleSites] = useState(0);
  const [fsbNotFeasibleSites, setFsbNotFeasibleSites] = useState(0);
  const [fsbPendingFeasibleSites, setFsbPendingFeasibleSites] = useState(0);
  const [fsbPendingForThirdPartySites, setFsbPendingForThirdPartySites] = useState(0);
  const [fsbDownloadPercentage, setFsbDownloadPercentage] = useState(0);
  const [fsbFilterList, setFsbFilterList] = useState([]);
  const [fsbFilterValue, setFsbFilterValue] = useState(defaultFilterOptions[0]);
  const [fsbSearchType, setFsbSearchType] = useState('');
  const [fsbSearchValue, setFsbSearchValue] = useState('');
  const [fsbTableRows, setFsbTableRows] = useState(fsb_tableHeader);
  const [fsbTableColumn, setFsbTableColumn] = useState([]);
  const [fsbDataPerPageValue, setFsbDataPerPageValue] = useState(defaultDataPerPageOptions[0]);
  const [fsbDataPerPageOptions, setFsbDataPerPageOptions] = useState(defaultDataPerPageOptions);
  const [fsbCurrentPage, setFsbCurrentPage] = useState(1);
  const [fsbFilterApplied, setFsbFiltersApplied] = useState(false);
  const [fsbMultiSortArr, setFsbMultiSortArr] = useState([]);
  const [fsbSelectedFilters, setFsbSelectedFilters] = useState({});
  const [isFeasibilityReportDownloading, setIsFeasibilityReportDownloading] = useState(false);

  // cart table state
  const [cartTotalSitesProcessed, setCartTotalSitesProcessed] = useState(0);
  const [cartTotalPages, setCartTotalPages] = useState(0);
  const [cartFilterList, setCartFilterList] = useState([]);
  const [cartFilterValue, setCartFilterValue] = useState(defaultFilterOptions[0]);
  const [cartSearchType, setCartSearchType] = useState('');
  const [cartSearchValue, setCartSearchValue] = useState('');
  const [cartTableRows, setCartTableRows] = useState(cart_tableHeader);
  const [cartTableColumn, setCartTableColumn] = useState([]);
  const [cartDataPerPageValue, setCartDataPerPageValue] = useState(defaultDataPerPageOptions[0]);
  const [cartDataPerPageOptions, setCartDataPerPageOptions] = useState(defaultDataPerPageOptions);
  const [cartCurrentPage, setCartCurrentPage] = useState(1);
  const [showCartEditModal, setShowCartEditModal] = useState(false);
  const [cartFilterApplied, setCartFiltersApplied] = useState(false);
  const [cartMultiSortArr, setCartMultiSortArr] = useState([]);
  const [cartIsEdit, setCartIsEdit] = useState(false);
  const [cartEditFileMeta, setCartEditFileMeta] = useState({});

  const [showCanceLeadPopup, setShowCancelLeadPopup] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [circuitModalDataSet, setCircuitModalData] = useState({});
  const [showCircuitDetailModal, setShowCircuitDetailModal] = useState(false);

  const isTMORedirect = leadIdFromParam || cartIdFromParam;

  useEffect(() => {
    window.scrollTo(0, 0);
    disableBackButton();
    showSteps(true);
    setActiveStep(2);

    if (isTMORedirect) {
      leadIdFromParam && setInSessionStorage(MULTI_SITE_MODULE_ID, LEAD_ID, leadIdFromParam);
      cartIdFromParam && setInSessionStorage(MULTI_SITE_MODULE_ID, CART_ID, cartIdFromParam);
    }

    toggelToastPopup();
    populateFsbTable();
  }, []);

  useEffect(() => {
    if (selectedCartId && selectedCartStatus) {
      setInSessionStorage(MULTI_SITE_MODULE_ID, CART_ID, selectedCartId);
      setInSessionStorage(MULTI_SITE_MODULE_ID, CART_STATUS, selectedCartStatus);
    }
  }, [selectedCartId, selectedCartStatus]);

  useEffect(() => {
    if (isBulkUpgrade()) {
      setFsbTableRows(fsb_tableHeader);
      setCartTableRows(cart_tableHeader);
      populateFsbTable();
    }
  }, [isBulkUpgrade()]);

  const getCbInterval = () => {
    const areCartSitesGreaterThanFeasibleSites = parseInt(fsbDownloadPercentage) !== 100 && !cartIsEdit && cartTotalSitesProcessed > fsbFeasibleSites;

    return cartIsEdit || (parseInt(fsbDownloadPercentage) === 100 && fsbPendingFeasibleSites === 0) ? null : areCartSitesGreaterThanFeasibleSites ? SHORT_CB_DELAY : CALLBACK_DELAY;
  };

  const toggelToastPopup = () => {
    setToast(false, '', '');
  };

  const navigateToPricingPage = () => {
    const { leadId, cartId, productType, user } = getLeadIdAndCartId();
    const queryParams = `?user=${user}&productType=${productType}&leadId=${leadId}&cartId=${cartId}${partyId ? `&partyId=${partyId}` : ''}&platform=AEH`;
    let redirectUrl = ROUTES.MULTI_SITE_PLAN_PRICING;
    history.push(redirectUrl + queryParams);
  };

  const naviagteToSummaryPage = ({ orderId }) => {
    const { leadId, cartId, productType, user } = getLeadIdAndCartId();
    const queryParam = `?journey=trackLead&platform=AEH&user=${user}&productType=${productType}&leadId=${leadId}&cartId=${cartId}&orderId=${orderId}${
      partyId ? `&partyId=${partyId}` : ''
    }`;
    history.push(ROUTES.DEDICATED_ORDER_SUMMARY + queryParam);
  };

  const blockRedirection = (cartItem) => {
    if (cartItem && (cartItem.cartStatus === CART_STAGE.CREATED || cartItem.cartStatus === CART_STAGE.LOCATIONS_SAVED)) {
      setIsAccordionExpandedForCart(!isAccordionExpandedForCart);
      setIsAccordionExpandedForFeasibilty(!isAccordionExpandedForFeasibilty);
      scrollToRef(cartContinerRef);
      return true;
    }
    return false;
  };
  const doNavigation = (item) => {
    setInSessionStorage(MULTI_SITE_MODULE_ID, CART_ID, item.cartId);
    const cartItem = cartDataListRef.current.find(({ cartId }) => cartId === item.cartId);

    if (cartItem && !blockRedirection(cartItem)) {
      switch (cartItem.cartStatus) {
        case PLAN_CONFIGURATION.PROGRESS:
          navigateToPricingPage();
          break;
        case PLAN_CONFIGURATION.PNQ_IN_PROGRESS:
          navigateToPricingPage();
          break;
        case PLAN_CONFIGURATION.PNQ_COMPLETED:
          navigateToPricingPage();
          break;
        case PLAN_CONFIGURATION.PNQ_CANCELED:
          navigateToPricingPage();
          break;
        case PLAN_CONFIGURATION.SAVED:
          navigateToPricingPage();
          break;
        case ORDER_STAGE.KYC_INPROGRESS:
          naviagteToSummaryPage(cartItem);
          break;
        case ORDER_STAGE.KYC_COMPLETED:
          redirectToTMO(cartItem);
          break;

        default:
          break;
      }
    }
  };

  const renderCartId = (item) => {
    return (
      <a href="javascript:void(0);" role="button" tabIndex="0" className="anchor-style" onClick={() => doNavigation(item)} title={item.cartId}>
        {item.cartId}
      </a>
    );
  };

  const addSiteTypeColumnForVPN = (item, key) => {
    if (item?.lineItemId) {
      return {
        [key]: {
          data: item?.siteType || '-'
        }
      };
    }
    return {};
  };

  const getColumnsForNLDorLL = (item) => {
    let bandwidth = item.feasibilityResponseBulk.requestedBandwidth && item.feasibilityResponseBulk.requestedBandwidth.toString();

    let installationAddress = `${item.address.addressLine1}, ${item.address.state ? `${item.address.state},` : ''} ${item.address.country}`;
    return {
      col1: {
        data: item?.linkId || '-',
        expandRow: true,
        rowSpan: 2
      },
      col2: {
        data: item.cartId ? renderCartId(item) : '-',
        expandRow: true,
        rowSpan: 2
      },
      col3: {
        data: bandwidth ? `${bandwidth} Mbps` : '-',
        expandRow: true,
        rowSpan: 2
      },
      col4: {
        data: removeUnderScoreWithSpace(item?.siteType) || '-'
      },
      col5: {
        data: installationAddress || '-',
        subData: `Branch Code: ${item.branchCode || '-'}`
      },
      col6: {
        data: item.feasibilityResponseBulk.feasibilityStatus ? (
          <li className={getFeasibilityStatusStyle(item.feasibilityResponseBulk.feasibilityStatus)}>{getFeasibilityText(item.feasibilityResponseBulk.feasibilityStatus)}</li>
        ) : (
          '-'
        )
      },
      col7: {
        data: <MediaType feasibilityResponseBulk={item?.feasibilityResponseBulk}></MediaType>
      }
    };
  };

  const getColumnsForDI_VPN = (item) => {
    let bandwidth = item.feasibilityResponseBulk.requestedBandwidth && item.feasibilityResponseBulk.requestedBandwidth.toString();

    let installationAddress = `${item.address.addressLine1}, ${item.address.state ? `${item.address.state},` : ''} ${item.address.country}`;
    return {
      col1: {
        data: removeLastString(item.lineItemId) || '-',
        expandRow: item?.dualLastMile,
        rowSpan: 2
      },
      col2: {
        data: item.cartId ? renderCartId(item) : '-',
        expandRow: item?.dualLastMile,
        rowSpan: 2
      },
      col3: {
        data: installationAddress || '-',
        subData: `Branch Code: ${item.branchCode || '-'}`,
        expandRow: item?.dualLastMile,
        rowSpan: 2
      },
      ...addSiteTypeColumnForVPN(item, 'col4'),

      col5: {
        data: item.feasibilityResponseBulk.feasibilityStatus ? (
          <li className={getFeasibilityStatusStyle(item.feasibilityResponseBulk.feasibilityStatus)}>{getFeasibilityText(item.feasibilityResponseBulk.feasibilityStatus)}</li>
        ) : (
          '-'
        )
      },
      col6: {
        data: bandwidth ? `${bandwidth} Mbps` : '-'
      },
      col7: {
        data: <MediaType feasibilityResponseBulk={item?.feasibilityResponseBulk}></MediaType>
      }
    };
  };

  const getCartColumnsForNLDorLL = (item) => {
    let bandwidth = item.feasibilityResponseBulk.requestedBandwidth && item.feasibilityResponseBulk.requestedBandwidth.toString();

    let installationAddress = `${item.address.addressLine1}, ${item.address.state ? `${item.address.state},` : ''} ${item.address.country}`;
    return {
      col1: {
        data: item.linkId || '-',
        expandRow: true,
        rowSpan: 2
      },
      col2: {
        data: bandwidth ? `${bandwidth} Mbps` : '-',
        expandRow: true,
        rowSpan: 2
      },
      col3: {
        data: removeUnderScoreWithSpace(item?.siteType) || '-'
      },
      col4: {
        data: installationAddress || '-',
        subData: `Branch Code: ${item.branchCode || '-'}`
      },
      col5: {
        data: <MediaType feasibilityResponseBulk={item?.feasibilityResponseBulk}></MediaType>
      }
    };
  };

  const getCartColumnsForDI_VPN = (item) => {
    let bandwidth = item.feasibilityResponseBulk.requestedBandwidth && item.feasibilityResponseBulk.requestedBandwidth.toString();

    let installationAddress = `${item.address.addressLine1}, ${item.address.state ? `${item.address.state},` : ''} ${item.address.country}`;
    return {
      col1: {
        data: removeLastString(item.lineItemId) || '-',
        expandRow: item?.dualLastMile,
        rowSpan: 2
      },
      col2: {
        data: installationAddress || '-',
        subData: `Branch Code: ${item.branchCode || '-'}`,
        expandRow: item?.dualLastMile,
        rowSpan: 2
      },
      ...addSiteTypeColumnForVPN(item, 'col3'),

      col4: {
        data: bandwidth ? `${bandwidth} Mbps` : '-'
      },
      col5: {
        data: <MediaType feasibilityResponseBulk={item?.feasibilityResponseBulk}></MediaType>
      }
    };
  };

  const getFeasibilityTableRows = (item) => {
    const {
      circuitId,
      branchCode,
      lsiDetail: {
        currentBandwidth,
        currentMedia,
        installationAddress: { addressLine1, state, country } = {
          addressLine1: '',
          state: '',
          country: ''
        },
        requestedBandwidth,
        requestedHardwareType,
        requestedServiceType
      },
      feasibilityResponseBulk
    } = item;

    const eligibleMedia =
      feasibilityResponseBulk && feasibilityResponseBulk.eligibleMedia && feasibilityResponseBulk.eligibleMedia[0] && feasibilityResponseBulk.eligibleMedia[0].media;
    const circuitEle = (
      <a href="javascript:void(0);" role="button" tabIndex={0} className="anchor-style" onClick={() => renderCircuitDetailModal(circuitId)} title={circuitId}>
        {circuitId}
      </a>
    );

    const installationAddressEle = addressLine1 ? `${addressLine1}, ${state ? `${state},` : ''} ${country}` : '-';

    const getHardwareColumnData = () => {
      if (requestedServiceType === 'MANAGED') {
        return {
          data: getCurrentServiceType(requestedServiceType),
          subData: `${requestedHardwareType} Hardware`
        };
      }

      return {
        data: getCurrentServiceType(requestedServiceType),
        subData: '-'
      };
    };

    return {
      col1: {
        data: circuitEle || '-'
      },
      col2: {
        data: item.cartId ? renderCartId(item) : '-'
      },
      col3: {
        data: installationAddressEle,
        subData: `Branch Code: ${branchCode || '-'}`
      },
      col4: {
        data:
          feasibilityResponseBulk && feasibilityResponseBulk.feasibilityStatus ? (
            <li className={getFeasibilityStatusStyle(feasibilityResponseBulk.feasibilityStatus)}>{getFeasibilityText(feasibilityResponseBulk.feasibilityStatus)}</li>
          ) : (
            '-'
          ),
        subData: feasibilityResponseBulk?.feasibilityStatus === 'FEASIBLE' ? `Feasible Media: ${eligibleMedia}` : ''
      },
      col5: {
        data: currentBandwidth,
        subData: `Media Type: ${currentMedia}`
      },
      col6: {
        data: `${requestedBandwidth} Mbps`
      },
      col7: getHardwareColumnData()
    };
  };

  const renderCircuitDetailModal = async (circuitId) => {
    setShowLoader(true);
    try {
      const { res, err } = await upgradeFetchCircuitDetails(circuitId);

      if (res) {
        setShowLoader(false);

        const { data: { success = false, result = {} } = {} } = res;
        if (success) {
          setCircuitModalData(result);
          setShowCircuitDetailModal(true);
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);
        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getCartTableRows = (item) => {
    const {
      circuitId,
      branchCode,
      lsiDetail: {
        installationAddress: { addressLine1, state, country } = {
          addressLine1: '',
          state: '',
          country: ''
        },
        requestedBandwidth,
        requestedHardwareType,
        requestedRouterMake,
        requestedRouterModel,
        requestedServiceType
      }
    } = item;

    const circuitEle = (
      <a href="javascript:void(0);" role="button" tabIndex={0} className="anchor-style" onClick={() => renderCircuitDetailModal(circuitId)} title={circuitId}>
        {circuitId}
      </a>
    );

    const installationAddressEle = addressLine1 ? `${addressLine1}, ${state ? `${state},` : ''} ${country}` : '-';

    const getHardwareColumnData = () => {
      if (requestedServiceType === 'MANAGED') {
        return {
          data: getCurrentServiceType(requestedServiceType),
          subData: `${requestedHardwareType} Hardware`
        };
      }

      return {
        data: getCurrentServiceType(requestedServiceType),
        subData: '-'
      };
    };

    const getRouterMakeModelColumnData = () => {
      if (requestedServiceType === 'MANAGED') {
        return {
          data: requestedRouterMake && requestedRouterMake.toUpperCase(),
          subData: requestedRouterModel && requestedRouterModel.toUpperCase()
        };
      }

      return {
        data: '-'
      };
    };

    return {
      col1: {
        data: circuitEle || '-'
      },
      col2: {
        data: installationAddressEle,
        subData: `Branch Code: ${branchCode || '-'}`
      },
      col3: {
        data: `${requestedBandwidth} Mbps`
      },
      col4: getHardwareColumnData(),
      col5: getRouterMakeModelColumnData()
    };
  };

  const retry4gFailedSites = async () => {
    try {
      setShowLoader(true);
      const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);

      const leadId = getFromSessionStorage(MULTI_SITE_MODULE_ID, LEAD_ID);

      const { res, err } = await retry4gFeasibility(leadId, leadAuthToken);
      if (res) {
        setShowLoader(false);
        setTimeout(() => {
          populateFsbTable();
        }, 200);
      } else if (err) {
        let errorMsg = (err && err.response && err.response.data && err.response.data.errorCode) || DEFAULT_TOAST_MSG;

        if (isBulkUpgrade()) {
          const error = await (err && err.response && err.response.data && err.response.data.text());
          const parsedError = JSON.parse(error);
          errorMsg = (parsedError && parsedError.errorMsg) || DEFAULT_TOAST_MSG;
        }

        setShowLoader(false);
        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      setShowLoader(false);
      console.error(e);
    }
  };

  // 10 seconds debounced callback for 4g retry click
  const throttled4gRetry = throttle(() => {
    retry4gFailedSites();
  }, THROTTLE_TIMEOUT_4G);

  const populateFsbTable = async (page, size, filterParams = fsbSelectedFilters, filtersApplied = fsbFilterApplied) => {
    try {
      setShowLoader(true);
      const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);

      const activePage = page || fsbCurrentPage - 1;
      const activeDataPerPage = size || (fsbDataPerPageValue && fsbDataPerPageValue.key);

      const defaultFilterParam = {
        fields: LINE_ITEM_FIELDS_PARAMS.FEASIBILITY_STATUS_MAP
      };

      filterParams = { ...defaultFilterParam, ...filterParams };

      const { res, err } = await fetchLocationDetails(leadAuthToken, activePage, activeDataPerPage, filterParams ? filterParams : {});
      if (res) {
        const { data: { success = false, result = {} } = {} } = res;
        let { totalActiveAddressCount = '', totalElement = '', totalPages = '', feasibilityStatusMap = {}, content = [] } = result;

        if (success) {
          setShowLoader(false);

          const tableColumnsList = [];

          let percentDownloaded = 100;

          const countSitesResolving = feasibilityStatusMap['PENDING'] || 0;
          const sitesProcessed = totalActiveAddressCount - countSitesResolving;
          const countOfProcessSite = isNLD_OR_LL() ? Math.floor(sitesProcessed / 2) : sitesProcessed;

          if (!filtersApplied) {
            percentDownloaded = ((sitesProcessed / totalActiveAddressCount) * 100).toFixed();

            // let toastMsg = getFeasibilityWarningText({ feasibilityStatusMap, totalElement });
            const { infoMsg, infoType } = get4gFailureMessage({ feasibilityStatusMap, totalElement, throttled4gRetry });

            parseInt(percentDownloaded) === 100 && infoMsg && infoType && setToast(true, infoMsg, infoType);
            // parseInt(percentDownloaded) === 100 && feasibilityStatusMap['MANUAL_INTERVENTION_REQUIRED'] && setToast(true, toastMsg, WARNING_TOAST);
            parseInt(percentDownloaded) === 100 && totalActiveAddressCount > 0 && getFsbDataPerPageAndBwList(totalActiveAddressCount);
            feasibilityStatusMap['FEASIBLE'] > 0 && feasibilityStatusMap['FEASIBLE'] !== fsbFeasibleSites && cartIdFromParam
              ? populateCartTableFromParamsCartId()
              : populateCartTable();

            setFsbFeasibleSites(feasibilityStatusMap['FEASIBLE'] || 0);
            setFsbPendingFeasibleSites(feasibilityStatusMap['PENDING'] || 0);
            setFsbManualFeasibleSites(feasibilityStatusMap['MANUAL_INTERVENTION_REQUIRED'] || 0);
            setFsbNotFeasibleSites(feasibilityStatusMap['NOT_FEASIBLE'] || 0);
            setFsbPendingForThirdPartySites(feasibilityStatusMap['PENDING_FOR_THIRD_PARTY'] || 0);
          } else {
            percentDownloaded = 100;
          }

          setFsbTotalSitesProcessing(countOfProcessSite);
          setFsbDownloadPercentage(percentDownloaded);
          setFsbTotalPages(totalPages);
          setFsbTotalSitesProcessed(countOfProcessSite);

          if (content && content.length > 0) {
            const getTableRows = (item) => {
              if (isBulkUpgrade()) {
                return getFeasibilityTableRows(item);
              }

              if (isNLD_OR_LL()) {
                return getColumnsForNLDorLL(item);
              }

              return getColumnsForDI_VPN(item);
            };

            content.forEach((item) => {
              const columns = getTableRows(item);
              tableColumnsList.push(columns);
            });
          }

          setFsbTableColumn(tableColumnsList);
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);
        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useInterval(populateFsbTable, getCbInterval());

  useEffect(() => {
    const selectedKey = fsbDataPerPageValue && fsbDataPerPageValue.key;
    let filterParams = {};

    if (fsbSearchType && fsbSearchValue) {
      filterParams[fsbSearchType['key']] = fsbSearchValue;
    }
    if (fsbFilterValue && fsbFilterValue.displayName !== 'All') {
      filterParams[fsbFilterValue['key']] = fsbFilterValue.displayName;
    }

    if (fsbMultiSortArr.length > 0) {
      fsbMultiSortArr.forEach((item, index) => {
        filterParams[`sort[${index}].field`] = item.key;
        filterParams[`sort[${index}].ascending`] = item.value;
      });
    }

    setFsbSelectedFilters(filterParams);
    let timeoutId;
    if (fsbFilterApplied) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => populateFsbTable(fsbCurrentPage - 1, selectedKey, filterParams), fsbSearchType && fsbSearchValue ? SHORT_CB_DELAY : 0);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [fsbDataPerPageValue, fsbCurrentPage, fsbFilterValue, fsbSearchType, fsbSearchValue, fsbMultiSortArr, fsbFilterApplied]);

  const getFsbDataPerPageAndBwList = async (fsbTotalAddressCount) => {
    try {
      setShowLoader(true);

      const nearest10digitNumber = fsbTotalAddressCount > 10 ? Math.ceil(fsbTotalAddressCount / 10) * 10 : fsbTotalAddressCount;

      const filteredArr = defaultDataPerPageOptions.filter((item) => item.key <= nearest10digitNumber);

      if (filteredArr.length > 0) {
        setFsbDataPerPageOptions(filteredArr);
      } else {
        setFsbDataPerPageOptions(defaultDataPerPageOptions);
      }

      const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);

      const defaultFilterParam = {
        fields: LINE_ITEM_FIELDS_PARAMS.FEASIBILITY_STATUS_MAP
      };

      const { res, err } = await fetchLocationDetails(leadAuthToken, 0, fsbTotalAddressCount, defaultFilterParam);

      if (res) {
        const { data: { success = false, result = {} } = {} } = res;
        const { content = [] } = result;

        if (success) {
          setShowLoader(false);
          if (content && content.length > 0) {
            const bandwidthList = [];

            content.forEach((item) => {
              let bandwidth = item.feasibilityResponseBulk.requestedBandwidth && item.feasibilityResponseBulk.requestedBandwidth.toString();

              const hasValue = bandwidthList.some((item) => item.displayName === bandwidth);

              if (!hasValue) {
                let bandwidthObj = {
                  key: 'bandwidth',
                  displayName: bandwidth
                };
                bandwidthList.push(bandwidthObj);
              }
            });
            setFsbFilterList([...defaultFilterOptions, ...bandwidthList].sort((a, b) => a.displayName - b.displayName));
          }
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);
        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getCartDataPerPageAndBwList = async (cartTotalAddressCount) => {
    try {
      setShowLoader(true);

      const nearest10digitNumber = cartTotalAddressCount > 10 ? Math.ceil(cartTotalAddressCount / 10) * 10 : cartTotalAddressCount;

      const filteredArr = defaultDataPerPageOptions.filter((item) => item.key <= nearest10digitNumber);

      if (filteredArr.length > 0) {
        setCartDataPerPageOptions(filteredArr);
      } else {
        setCartDataPerPageOptions(defaultDataPerPageOptions);
      }

      const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);

      const defaultFilterParam = {
        fields: LINE_ITEM_FIELDS_PARAMS.FEASIBILITY_STATUS_MAP
      };

      const { res, err } = await fetchLocationDetails(leadAuthToken, 0, cartTotalAddressCount, defaultFilterParam);

      if (res) {
        const { data: { success = false, result = {} } = {} } = res;
        const { content = [] } = result;

        if (success) {
          setShowLoader(false);
          if (content && content.length > 0) {
            const bandwidthList = [];

            content.forEach((item) => {
              let bandwidth = item.feasibilityResponseBulk.requestedBandwidth && item.feasibilityResponseBulk.requestedBandwidth.toString();

              const hasValue = bandwidthList.some((item) => item.displayName === bandwidth);

              if (!hasValue) {
                let bandwidthObj = {
                  key: 'bandwidth',
                  displayName: bandwidth
                };
                bandwidthList.push(bandwidthObj);
              }
            });
            setCartFilterList([...defaultFilterOptions, ...bandwidthList].sort((a, b) => a.displayName - b.displayName));
          }
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);
        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    const selectedKey = cartDataPerPageValue && cartDataPerPageValue.key;
    let filterParams = {};

    if (cartSearchType && cartSearchValue) {
      filterParams[cartSearchType['key']] = cartSearchValue;
    }

    if (cartFilterValue && cartFilterValue.displayName !== 'All') {
      filterParams[cartFilterValue['key']] = cartFilterValue.displayName;
    }

    if (cartMultiSortArr.length > 0) {
      cartMultiSortArr.forEach((item, index) => {
        filterParams[`sort[${index}].field`] = item.key;
        filterParams[`sort[${index}].ascending`] = item.value;
      });
    }

    let timeoutId;
    if (cartFilterApplied) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(
        () =>
          cartIdFromParam ? populateCartTableFromParamsCartId(cartCurrentPage - 1, selectedKey, filterParams) : populateCartTable(cartCurrentPage - 1, selectedKey, filterParams),
        cartSearchType && cartSearchValue ? SHORT_CB_DELAY : 0
      );
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [cartDataPerPageValue, cartCurrentPage, cartFilterValue, cartSearchType, cartSearchValue, cartMultiSortArr, cartFilterApplied]);

  const disableBackButton = () => {
    window.history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      window.history.pushState(null, null, document.URL);
    });
  };

  const populateCartTableFromParamsCartId = async (page, size, filterParams, isFilterApplied = cartFilterApplied) => {
    setShowLoader(true);

    // for cart site count in header - loading shimmer
    setCartSitesLoading(true);
    try {
      if (cartIdFromParam) {
        setSelectedCartId(cartIdFromParam);
        setSelectedCartStatus(LOCATIONS_SAVED);

        const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);

        const activePage = page || cartCurrentPage - 1;
        const activeDataPerPage = size || (cartDataPerPageValue && cartDataPerPageValue.key);
        const cartIdParam = {
          cartId: cartIdFromParam
        };

        const defaultFilterParam = {
          fields: LINE_ITEM_FIELDS_PARAMS.FEASIBILITY_STATUS_MAP
        };

        let combinedExtraParams = {};

        if (filterParams && cartIdFromParam) {
          combinedExtraParams = {
            ...cartIdParam,
            ...filterParams
          };
        } else if (cartIdFromParam) {
          combinedExtraParams = {
            ...cartIdParam
          };
        } else {
          combinedExtraParams = {
            ...filterParams
          };
        }

        combinedExtraParams = { ...defaultFilterParam, ...combinedExtraParams };

        const { res, err } = await fetchLocationDetails(leadAuthToken, activePage, activeDataPerPage, combinedExtraParams ? combinedExtraParams : {});
        if (res) {
          const { data: { success = false, result = {} } = {} } = res;

          if (success) {
            setShowLoader(false);
            setCartSitesLoading(false);

            const { totalElement = '', totalPages = '', content = [] } = result;

            const tableColumnsList = [];

            setCartTotalPages(totalPages);
            const cartCounts = isNLD_OR_LL() ? Math.floor(totalElement / 2) : totalElement;
            setCartTotalSitesProcessed(cartCounts);

            if (!isFilterApplied) {
              const toastMsg = `${
                cartEditFileMeta && cartEditFileMeta['name'] ? cartEditFileMeta['name'] : 'Cart-Bulk_Upload_DI.xlsx'
              } has been successfully updated on the system.`;

              cartIsEdit && setToast(true, toastMsg, SUCCESS_TOAST);
              totalElement > 0 && getCartDataPerPageAndBwList(totalElement);
            }

            if (content && content.length > 0) {
              const getTableRows = (item) => {
                if (isBulkUpgrade()) {
                  return getCartTableRows(item);
                }

                if (isNLD_OR_LL()) {
                  return getCartColumnsForNLDorLL(item);
                }

                return getCartColumnsForDI_VPN(item);
              };

              content.forEach((item) => {
                const columns = getTableRows(item);
                tableColumnsList.push(columns);
              });
            }

            setCartTableColumn(tableColumnsList);
          }
        } else if (err) {
          const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

          setShowLoader(false);
          setCartSitesLoading(false);

          setToast(true, errorMsg, ERROR_TOAST);
          throw new Error(errorMsg);
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const populateCartTable = async (page, size, filterParams, isFilterApplied = cartFilterApplied) => {
    try {
      setShowLoader(true);
      setCartSitesLoading(true);

      const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);

      const { res, err } = await cartSearch(leadAuthToken, false);

      if (res) {
        const { data: { success = false, result = {} } = {} } = res;

        if (success) {
          const { cartDataList = [] } = result;
          let selectedCartId = '';
          let selectedCartStatus = '';

          let locationSavedCartItem = {};
          let createdCartItem = {};

          if (cartDataList && cartDataList.length > 0) {
            locationSavedCartItem = cartDataList.find((item) => item.cartStatus === LOCATIONS_SAVED) || {};
            createdCartItem = cartDataList.find((item) => item.cartStatus === CREATED) || {};
          }

          if (Object.keys(locationSavedCartItem).length > 0) {
            selectedCartId = locationSavedCartItem.cartId;
            selectedCartStatus = locationSavedCartItem.cartStatus;
          } else {
            selectedCartId = createdCartItem.cartId;
            selectedCartStatus = createdCartItem.cartStatus;
          }

          cartDataListRef.current = cartDataList;
          setSelectedCartId(selectedCartId);
          setSelectedCartStatus(selectedCartStatus);

          if (selectedCartId) {
            const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);

            const activePage = page || cartCurrentPage - 1;
            const activeDataPerPage = size || (cartDataPerPageValue && cartDataPerPageValue.key);
            const cartIdParam = {
              cartId: selectedCartId
            };

            const defaultFilterParam = {
              fields: LINE_ITEM_FIELDS_PARAMS.FEASIBILITY_STATUS_MAP
            };

            let combinedExtraParams = {};

            if (filterParams && selectedCartId) {
              combinedExtraParams = {
                ...cartIdParam,
                ...filterParams
              };
            } else if (selectedCartId) {
              combinedExtraParams = {
                ...cartIdParam
              };
            } else {
              combinedExtraParams = {
                ...filterParams
              };
            }

            combinedExtraParams = {
              ...defaultFilterParam,
              ...combinedExtraParams
            };

            const { res, err } = await fetchLocationDetails(leadAuthToken, activePage, activeDataPerPage, combinedExtraParams ? combinedExtraParams : {});
            if (res) {
              const { data: { success = false, result = {} } = {} } = res;

              if (success) {
                setShowLoader(false);
                setCartSitesLoading(false);

                const { totalElement = '', totalPages = '', content = [] } = result;

                const tableColumnsList = [];

                setCartTotalPages(totalPages);
                const cartCounts = isNLD_OR_LL() ? Math.floor(totalElement / 2) : totalElement;
                setCartTotalSitesProcessed(cartCounts);

                if (!isFilterApplied) {
                  const toastMsg = `${
                    cartEditFileMeta && cartEditFileMeta['name'] ? cartEditFileMeta['name'] : 'Cart-Bulk_Upload_DI.xlsx'
                  } has been successfully updated on the system.`;

                  cartIsEdit && setToast(true, toastMsg, SUCCESS_TOAST);
                  totalElement > 0 && getCartDataPerPageAndBwList(totalElement);
                }

                if (content && content.length > 0) {
                  const getTableRows = (item) => {
                    if (isBulkUpgrade()) {
                      return getCartTableRows(item);
                    }

                    if (isNLD_OR_LL()) {
                      return getCartColumnsForNLDorLL(item);
                    }

                    return getCartColumnsForDI_VPN(item);
                  };

                  content.forEach((item) => {
                    const columns = getTableRows(item);
                    tableColumnsList.push(columns);
                  });
                }

                setCartTableColumn(tableColumnsList);
              }
            } else if (err) {
              const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

              setShowLoader(false);
              setCartSitesLoading(false);

              setToast(true, errorMsg, ERROR_TOAST);
              throw new Error(errorMsg);
            }
          }
        } else if (err) {
          const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

          setShowLoader(false);
          setCartSitesLoading(false);

          setToast(true, errorMsg, ERROR_TOAST);
          throw new Error(errorMsg);
        }
      } else {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);
        setCartSitesLoading(false);

        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getFeasibilityStatusStyle = (type) => {
    if (type === 'FEASIBLE') {
      return 'text_status text_status_resolved no-wrap';
    }

    if (type === 'PENDING') {
      return 'text_status text_status_warning no-wrap';
    }
    if (type === 'MANUAL_INTERVENTION_REQUIRED') {
      return 'text_status text_status_warning no-wrap';
    }
    if (type === 'NOT_FEASIBLE') {
      return 'text_status text_status_error no-wrap';
    }
    if (type === 'PENDING_FOR_THIRD_PARTY') {
      return 'text_status text_status_pending no-wrap';
    }
    if (type === FEASIBILITY_STATUS_ENUM.FAILED_4G) {
      return 'text_status text_status_pending no-wrap';
    }

    return 'text_status text_status_pending no-wrap';
  };

  const getFeasibilityText = (type) => {
    if (type === 'FEASIBLE') {
      return 'Feasible';
    }
    if (type === 'PENDING') {
      return 'Manual Feasibility';
    }
    if (type === 'MANUAL_INTERVENTION_REQUIRED') {
      return 'Manual Feasibility';
    }
    if (type === 'NOT_FEASIBLE') {
      return 'Not Feasible';
    }
    if (type === 'PENDING_FOR_THIRD_PARTY') {
      return 'Third Party Pending';
    }
    if (type === FEASIBILITY_STATUS_ENUM.FAILED_4G) {
      return 'Error Occurred';
    }

    return '-';
  };

  const handleGoBack = () => setShowCancelLeadPopup(true);

  const handleFsbReportDownload = async () => {
    try {
      setShowLoader(true);
      setIsFeasibilityReportDownloading(true);

      const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);

      const leadId = getFromSessionStorage(MULTI_SITE_MODULE_ID, LEAD_ID);

      const { res, err } = await feasibilityReportDownload(isdedicatedJourney, leadId, leadAuthToken);
      if (res) {
        const { data = {} } = res;
        setShowLoader(false);
        setIsFeasibilityReportDownloading(false);

        const fileName = getFileName(res, 'Feasibility_Report_DI.xlsx');
        downloadFileURI(data, fileName);
      } else if (err) {
        let errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        if (isBulkUpgrade()) {
          const error = await (err && err.response && err.response.data && err.response.data.text());
          const parsedError = JSON.parse(error);
          errorMsg = (parsedError && parsedError.errorMsg) || DEFAULT_TOAST_MSG;
        }

        setShowLoader(false);
        setIsFeasibilityReportDownloading(false);

        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      setShowLoader(false);
      setIsFeasibilityReportDownloading(false);

      console.error(e);
    }
  };

  const handleFileUpload = (uploadedFiles, isFileUploaded) => {
    setCartIsEdit(isFileUploaded);
    setCartEditFileMeta(uploadedFiles[0]);
    setCartFiltersApplied(false);
    setCartSearchType('');
    setCartSearchValue('');
    setCartFilterValue(defaultFilterOptions[0]);
  };

  const handleCartEditSubmit = () => {
    cartIdFromParam ? populateCartTableFromParamsCartId(null, null, null, false) : populateCartTable(null, null, null, false);
    setShowCartEditModal(false);
    toggelToastPopup();
  };

  const handleCancelLead = async (remarks) => {
    try {
      setShowLoader(true);
      const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);

      const reqData = {
        remarks
      };
      const { res, err } = await cancelLead(reqData, leadAuthToken, isdedicatedJourney);
      if (res) {
        const { data: { success = false } = {} } = res;
        if (success) {
          setShowLoader(false);
          toggelToastPopup();
          let redirectUrl = ROUTES.DEDICATED_CANCEL;
          if (partyId) {
            redirectUrl = redirectUrl + '?partyId=' + partyId;
          }
          history && history.push(redirectUrl, { ...getOrderDetails(), isUpgrade: isBulkUpgrade() });
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);

        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleGotoPlanPricingPage = async () => {
    try {
      setShowLoader(true);

      const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);

      const reqObj = {
        cartId: selectedCartId,
        status: PLAN_CONFIGURATION.PROGRESS
      };

      const { res, err } = await cartCheckout(leadAuthToken, reqObj);
      if (res) {
        const { data: { success = false, result = {} } = {} } = res;

        if (success) {
          const { cartId = '', cartStatus = '' } = result;

          setShowLoader(false);
          setSelectedCartId(cartId);
          setSelectedCartStatus(cartStatus);

          let redirectUrl = ROUTES.MULTI_SITE_PLAN_PRICING;
          if (partyId) {
            redirectUrl = redirectUrl + '?partyId=' + partyId;
          }

          if (isDevEnv() && isAuthForDev()) {
            redirectUrl = redirectUrl + '&isAuth=' + findParamFromUrl('isAuth', false);
          }

          history.push(redirectUrl);
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);

        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getSortValue = (value) => {
    if (value === 'ascending') {
      return 'descending';
    }
    if (value === 'descending') {
      return 'ascending';
    }

    return 'descending';
  };

  const handleFsbSortClick = (key, value) => {
    const updatedRows = fsbTableRows.map((item) => {
      if (item.sortKey === key) {
        item.sortValue = getSortValue(value);
      }
      return item;
    });

    const multiSortArrCpy = [...fsbMultiSortArr];

    const hasSortKey = multiSortArrCpy.some((item) => item.key === key);

    if (hasSortKey) {
      multiSortArrCpy.map((item) => {
        if (item.key === key) {
          item.value = getSortValue(value) === 'ascending' ? true : false;
        }

        return item;
      });
    } else {
      multiSortArrCpy.push({
        key,
        value: getSortValue(value) === 'ascending' ? true : false
      });
    }

    setFsbFiltersApplied(true);
    setFsbTableRows(updatedRows);
    setFsbMultiSortArr(multiSortArrCpy);
  };

  const handleCartSortClick = (key, value) => {
    const updatedRows = cartTableRows.map((item) => {
      if (item.sortKey === key) {
        item.sortValue = getSortValue(value);
      }
      return item;
    });

    const multiSortArrCpy = [...cartMultiSortArr];

    const hasSortKey = multiSortArrCpy.some((item) => item.key === key);

    if (hasSortKey) {
      multiSortArrCpy.map((item) => {
        if (item.key === key) {
          item.value = getSortValue(value) === 'ascending' ? true : false;
        }

        return item;
      });
    } else {
      multiSortArrCpy.push({
        key,
        value: getSortValue(value) === 'ascending' ? true : false
      });
    }

    setCartFiltersApplied(true);
    setCartTableRows(updatedRows);
    setCartMultiSortArr(multiSortArrCpy);
  };

  const getPopUpMessage = () => {
    if (isNLD_OR_LL()) {
      return `${cartTotalSitesProcessed} feasible ${
        cartTotalSitesProcessed > 1 ? 'links are' : 'link is'
      } added to the cart for pricing and quotation. Are you sure you want to proceed?`;
    }
    return `${cartTotalSitesProcessed} feasible ${cartTotalSitesProcessed > 1 ? 'sites are' : 'site is'} added to the cart for pricing and ${
      isBulkUpgrade() ? 'configuration' : 'quotation'
    }. Are you sure you want to proceed?`;
  };

  return (
    <div className="bulk-feasibility">
      {showCanceLeadPopup && <CancelModal setshowPopup={setShowCancelLeadPopup} onSubmit={handleCancelLead} />}
      {showConfirmationPopup && (
        <CustomModal
          customPopupTitle="Proceed to Select Plan & Configuration"
          customPopupMsg={getPopUpMessage()}
          submitCustomPopup={handleGotoPlanPricingPage}
          closeCustomPopup={() => setShowConfirmationPopup(false)}
          isLoading={showLoader}
        />
      )}
      {showCartEditModal && (
        <DrawerModalComponent
          isOpen={showCartEditModal}
          setIsOpen={setShowCartEditModal}
          title="Edit Cart with Excel"
          onSaveClick={handleCartEditSubmit}
          downloadHeading="Export Excel File of Feasible Sites"
          downloadSubHeading={getDownloadModalText()}
          downloadBtnName="Download Excel"
          toast={toast}
          setToast={setToast}
          currentPage={FILE_UPLOAD_PAGES.CART_FEASIBILITY}
          onDrawerUploadCb={handleFileUpload}
          {...props}
        />
      )}
      <CircuitDetail circuitModalDataSet={circuitModalDataSet} isOpen={showCircuitDetailModal} onClose={setShowCircuitDetailModal} />
      <AddressProcess
        isAccordionExpanded={isAccordionExpandedForFeasibilty}
        setIsAccordionExpanded={setIsAccordionExpandedForFeasibilty}
        hasAccordion
        showProcessComponent
        showFilterOptions
        setBottomMargin={cartTotalSitesProcessed === 0}
        processIdLabel="Feasibility Request ID:"
        processSiteLabel={isNLD_OR_LL() ? 'Total Links' : 'Total Sites Processed'}
        processId={getFromSessionStorage(MULTI_SITE_MODULE_ID, LEAD_ID) || leadIdFromParam}
        processSiteProcessed={fsbFilterApplied ? fsbTotalSitesProcessed : fsbTotalSitesProcessing}
        processBtnName="Download Feasibility Report"
        toolTipMessage={TOOLTIP_MESSAGE.DOWNLOAD_FEASIBILTY_REPORT}
        icon={
          <span
            className="material-icons-outlined"
            style={{
              top: 2,
              left: 10
            }}
          >
            file_download
          </span>
        }
        onProcessBtnClick={handleFsbReportDownload}
        processBtnDisabled={isFeasibilityReportDownloading}
        // processBtnDisabled={parseInt(fsbDownloadPercentage) !== 100}
        showProgressComponent={parseInt(fsbDownloadPercentage) === 100 || cartIsEdit ? false : true}
        showFeasibilityErrorStatus
        feasibleSites={fsbFeasibleSites}
        manualFeasibleSites={fsbManualFeasibleSites}
        notFeasibleSites={fsbNotFeasibleSites}
        pendingFeasibleSites={fsbPendingFeasibleSites}
        pendingForThirdPartySites={fsbPendingForThirdPartySites}
        noOfProcessingSites={fsbTotalSitesProcessed}
        percentageComplete={fsbDownloadPercentage}
        filterLabel="Bandwidth"
        filterValue={fsbFilterValue}
        filterOptions={fsbFilterList}
        filterOnChange={(value) => {
          setFsbFiltersApplied(true);
          setFsbFilterValue(value);
        }}
        searchType={fsbSearchType}
        onSearchTypeChange={(type) => {
          setFsbFiltersApplied(false);
          setFsbSearchType(type);
          setFsbSearchValue('');
        }}
        searchValue={fsbSearchValue}
        onSearchValueChange={(value) => {
          setFsbFiltersApplied(true);
          setFsbSearchValue(value);
        }}
        searchTypeOptions={defaultSearchTypeOptions}
        onSearchClick={() => {
          let filterParams = {};

          if (fsbSearchType && fsbSearchValue) {
            filterParams[fsbSearchType['key']] = fsbSearchValue;
          }
          populateFsbTable(null, null, filterParams);
        }}
        onClearFilter={() => {
          setFsbFiltersApplied(false);
          setFsbSearchType('');
          setFsbSearchValue('');
          setFsbDataPerPageValue(defaultDataPerPageOptions[0]);
          populateFsbTable(null, defaultDataPerPageOptions[0]?.key, null, false);
        }}
        rows={fsbTableRows}
        cols={fsbTableColumn}
        dataPerPageValue={fsbDataPerPageValue}
        dataPerPageOptions={fsbDataPerPageOptions}
        dataPerPageOnChange={(val) => {
          setFsbFiltersApplied(true);
          setFsbDataPerPageValue(val);
        }}
        currentPage={fsbCurrentPage}
        onPageSelect={(pageNo) => {
          setFsbFiltersApplied(true);
          setShowLoader(true);
          setFsbCurrentPage(pageNo);
        }}
        totalPages={fsbTotalPages}
        onSortClick={handleFsbSortClick}
        filterApplied={fsbFilterApplied}
        showLoader={showLoader}
        isRowSpanEnabled={(isNLD_OR_LL() || isVPN_OR_DI()) && !isBulkUpgrade()}
      />
      {fsbFeasibleSites > 0 && (
        <Fragment>
          <section className="multi_site_section container" ref={cartContinerRef}>
            <div className="header_title">
              <span className="title_text cart_title_text">Cart Details</span>
            </div>
          </section>
          <AddressProcess
            hasAccordion
            isAccordionExpanded={isAccordionExpandedForCart}
            setIsAccordionExpanded={setIsAccordionExpandedForCart}
            showProcessComponent
            showFilterOptions
            showFileName={cartIsEdit}
            fileData={cartEditFileMeta}
            showSubHeader={false}
            processIdLabel="Order Request Id: "
            processSiteLabel={isNLD_OR_LL() ? 'Total Links' : 'Total Sites Processed'}
            processId={getFromSessionStorage(MULTI_SITE_MODULE_ID, CART_ID) || cartIdFromParam}
            processSiteProcessed={cartTotalSitesProcessed}
            processBtnName="Edit Cart with Excel"
            toolTipMessage={TOOLTIP_MESSAGE.EDIT_WITH_EXCEL}
            onProcessBtnClick={() => {
              setShowCartEditModal(true);
            }}
            // noOfProcessingSites={cartTotalSitesProcessed}
            // percentageComplete={cartDownloadPercentage}
            filterLabel="Bandwidth"
            filterValue={cartFilterValue}
            filterOptions={cartFilterList}
            filterOnChange={(value) => {
              setCartFiltersApplied(true);
              setCartFilterValue(value);
            }}
            searchType={cartSearchType}
            onSearchTypeChange={(type) => {
              setCartFiltersApplied(false);
              setCartSearchType(type);
              setCartSearchValue('');
            }}
            searchValue={cartSearchValue}
            onSearchValueChange={(value) => {
              setCartFiltersApplied(true);
              setCartSearchValue(value);
            }}
            searchTypeOptions={defaultSearchTypeOptions}
            onSearchClick={() => {
              let filterParams = {};

              if (cartSearchType && cartSearchValue) {
                filterParams[cartSearchType['key']] = cartSearchValue;
              }
              cartIdFromParam ? populateCartTableFromParamsCartId(null, null, filterParams) : populateCartTable(null, null, filterParams);
            }}
            onClearFilter={() => {
              setCartFiltersApplied(false);
              setCartSearchType('');
              setCartSearchValue('');
              setCartFilterValue(defaultFilterOptions[0]);
              cartIdFromParam ? populateCartTableFromParamsCartId() : populateCartTable();
            }}
            rows={cartTableRows}
            cols={cartTableColumn}
            dataPerPageValue={cartDataPerPageValue}
            dataPerPageOptions={cartDataPerPageOptions}
            dataPerPageOnChange={(val) => {
              setCartFiltersApplied(true);
              setCartDataPerPageValue(val);
            }}
            currentPage={cartCurrentPage}
            onPageSelect={(pageNo) => {
              setCartFiltersApplied(true);
              setShowLoader(true);
              setCartCurrentPage(pageNo);
            }}
            totalPages={cartTotalPages}
            onSortClick={handleCartSortClick}
            filterApplied={cartFilterApplied}
            showLoader={showLoader}
            sitesLoading={cartSitesLoading}
            isRowSpanEnabled={(isNLD_OR_LL() || isVPN_OR_DI()) && !isBulkUpgrade()}
          />
        </Fragment>
      )}
      <BottomSection
        spaceBetween
        onSubmitClick={() => setShowConfirmationPopup(true)}
        onCancelClick={handleGoBack}
        isSubmitDisabled={cartTotalSitesProcessed === 0}
        title={isNLD_OR_LL() ? 'Total Links' : 'Feasible Sites in Cart'}
        value={cartTotalSitesProcessed}
      />
    </div>
  );
};

export default BulkFeasibilityComponent;
